import { FormElementKind } from "@/gql/graphql";

export type FormElementAttributesType = {
  id?: string | undefined;
  singleFileUrl?: string | null | undefined;
  singleFileSignedId?: string | null | undefined;
  singleFile?: File | null | undefined;
  multipleFileUrls?: string[] | null | undefined;
  multipleFileSignedIds?: string[] | null | undefined;
  required: boolean;
  kind: FormElementKind;
  sequence: number;
  arguments: Record<string, any>;
  _destroy?: boolean | undefined;
};

export const DragType = {
  COMPONENT: "Component",
  FORMCOMPONENT: "FormComponent",
};

export type ComponentProps = {
  componentType: FormElementAttributesType;
};

export type Level = 1 | 2 | 3 | 4 | 5 | 6;
